var poll_default = {
  "fontElementMap": "UbNbt",
  "container": "mxZSR",
  "fullscreen": "-PpJq",
  "background_overlay": "J-W8l",
  "with_image": "Z6qt1",
  "options": "mW9Ly",
  "webview": "ps9Di",
  "grid": "LkE4n",
  "option": "ZGnrP",
  "cta_button": "g5-XX",
  "add_option": "_59ypf",
  "see_more": "oVlvF",
  "list": "n6C4D",
  "column": "Rr6lk",
  "additional_note": "zkiEU",
  "spinner": "f9cEz",
  "spin": "IRh4X",
  "shown": "biMdo",
  "error": "An2A4"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
